import React from 'react';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { IProps, IState } from './interfaces';

import styles from './Confirm.module.styl';

class Confirm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isVisible: false,
    };
  }

  public componentDidMount() {
    this.init();
  }

  public render() {
    const { text, caption } = this.props.data;

    return (
      <div className={styles.root}>
        <DialogTitle id="responsive-dialog-title">
          {caption || 'Confirm'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleConfirm} color="primary">
            Confirm
          </Button>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </div>
    );
  }

  private init = () => {
    this.setState({
      isVisible: true,
    });
  };

  private handleClose = () => {
    const {
      data: { onClose },
      handleClose,
    } = this.props;
    if (typeof onClose === 'function') {
      onClose();
    }
    handleClose();
  };

  private handleConfirm = () => {
    this.props.data.onConfirm();
    this.props.handleClose();
  };
}

export default Confirm;
